export enum PerformanceClassification {
    service = 'service',
    efficiency = 'efficiency',
    employeeBehavioural = 'employeeBehavioural',
    cleanliness = 'cleanliness',
    product = 'product',
    salesOpportunity = 'salesOpportunity',
    food = 'food',
    sustainability = 'sustainability',
}

export const prettyPerformanceClassificationLabels: Record<PerformanceClassification, string> = {
    [PerformanceClassification.service]: 'Service',
    [PerformanceClassification.efficiency]: 'Efficiency',
    [PerformanceClassification.employeeBehavioural]: 'EI Behavioral',
    [PerformanceClassification.cleanliness]: 'Cleanliness',
    [PerformanceClassification.product]: 'Product',
    [PerformanceClassification.salesOpportunity]: 'Sales Opportunity',
    [PerformanceClassification.food]: 'Food Quality',
    [PerformanceClassification.sustainability]: 'Sustainability',
};

export const nonRenderableScoringTypes = {
    700: 'informational',
};
